import { jsx as l } from "react/jsx-runtime";
import '../../assets/Panel.css';const s = "_panel_ta6xy_1", t = "_visible_ta6xy_16", e = {
  panel: s,
  visible: t
}, n = ({ children: a, isOpen: i }) => /* @__PURE__ */ l(
  "div",
  {
    className: `${e.panel} ${i && e.visible} iOSPWA-panel`,
    "aria-describedby": "pwa-prompt-description",
    "aria-labelledby": "pwa-prompt-title",
    role: "dialog",
    children: a
  }
);
export {
  n as Panel
};
